import React from "react";

import { ProductData } from "data/product/products";
import { Details, SingleReview } from "data/videoProductPage";

import { ImageWithBlur } from "~/components/common/ImageWithBlur/ImageWithBlur";

import * as styles from "./Reviews.css";
import { ReviewItem } from "./SingleReview";

export const ReviewsSection = ({
  reviews,
  productData,
}: {
  reviews: SingleReview[];
  productData: ProductData;
}) => {
  const sortedReviews = reviews?.sort((a, b) => {
    return a.rankIndex - b.rankIndex;
  });

  return (
    <section className={styles.reviewsSection}>
      <div className={styles.reviewTitle}>
        <div className={styles.starImageContainer}>
          <ImageWithBlur
            src="https://res.cloudinary.com/monthly/image/upload/v1674460925/monthly-admin-images/behind-scenes-product/video-page/icon/star_FILL0_wght400_GRAD0_opsz48_2_krefee.svg"
            alt="star"
            layout="fill"
          />
        </div>
        {productData.ratingInfo?.numRatings && productData.ratingInfo.numRatings > 40 ? (
          <span>{`${productData.ratingInfo?.ratingScore} (${productData.ratingInfo?.numRatings} reviews)`}</span>
        ) : (
          <span>{"What students have to say about the class"}</span>
        )}
        <span></span>
      </div>
      <div className={styles.reviewsList}>
        {sortedReviews?.map((review: SingleReview, i: number) => (
          <ReviewItem key={i} review={review} />
        ))}
      </div>
      {/*<button className={styles.reviewShowMoreBtn} >Show more reviews</button>*/}
    </section>
  );
};
